import { FC, useEffect, useState } from 'react';
import { ReactComponent as IconAlert } from 'assets/img/statuses/iconAlert.svg';
import styles from './TabMenu.module.scss';
import { NavLink } from 'react-router-dom';

type TabMenuProps = {
  setActive: (key: string) => void;
  active: string;
  lists?: any[];
  cls?: any;
  action?: React.ReactNode;
};

export const TabMenu: FC<TabMenuProps> = ({
  setActive,
  active,
  lists = [],
  cls,
  action,
}) => {
  const handlerActive = (key: string) => {
    setActive(key);
  };

  const keyLists = lists.map((el) => el.key);

  useEffect(() => {
    const path = window.location.pathname;
    const filterPath = keyLists.forEach((el) => {
      if (path.includes(el)) {
        setActive(el);
      }
    });
  }, []);

  return (
    <div className={styles.container}>
      <div className={styles.root} style={cls}>
        {lists.map((item: any, i: number) => (
          <div
            className={`${styles.item} ${item.key === active ? styles.active : ''}`}
            key={i}
            onClick={() => handlerActive(item.key)}>
            {item.name}
          </div>
        ))}
      </div>
      {action && <div className={styles.actionWrapper}>{action}</div>}
    </div>
  );
};
